import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import UsersEditContain from '../../../Component/Proxies/AddProxy';
import { useTranslation } from 'react-i18next';

const UsersEdit = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Proxies")} title={t("Add Proxy")} />
      <UsersEditContain />
    </Fragment>
  );
};
export default UsersEdit;
